






























































































































































import BaseIcon from 'vuecomponents/base_icon.vue'
import MultilineInput from 'vuecomponents/multiline_input.vue'
import RelativeTime from 'library/v4/components/relative-time.vue'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import OzButton from 'library/v4/components/OzButton.vue'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { namespace, State, Getter } from 'vuex-class'
import { Comment, Id, User } from 'types'

@Component({
  components: { BaseIcon, AvatarImage, MultilineInput, RelativeTime, OzButton },
})
export default class SurfacePostCommentNew extends Mixins() {
  $refs!: {
    editCommentInput: MultilineInput & {
      $el: HTMLTextAreaElement
    }
  }
  @Prop() id!: Id
  @Prop() comment!: Comment & { html_body: any }
  @Prop() isBeingEdited!: boolean
  @Getter colorScheme!: 'dark' | 'light'
  @Getter isStream!: boolean
  @State user!: User
  @Getter canIModerate!: boolean
  @(namespace('userContributor').Getter) getUserById
  @(namespace('browser').Getter) isPhone!: boolean

  @(namespace('comment').Getter) editedDraftCommentBodyFromId!: (commentId) => string

  @(namespace('comment').Action) updateEditedDraftCommentBody!: (payload: { commentId; body: string }) => void

  get author(): User {
    return this.getUserById(this.comment.user_id) || this.user
  }
  get isRegistered(): boolean {
    return this.author.registered || !!this.author.registered_at
  }
  get hyperlinkedBody(): string {
    return this.comment.html_body || this.comment.body
  }
  get showActions(): boolean {
    return (this.user.id === this.comment.user_id || this.canIModerate) && !this.isBeingEdited
  }
  get isDark(): boolean {
    return this.colorScheme === 'dark'
  }
  mounted(): void {
    this.fetchUser(this.comment.user_id)
  }
  updated(): void {
    if (this.isBeingEdited && !this.isPhone) {
      this.$refs.editCommentInput.focus()
    }
  }
  @(namespace('userContributor').Action) fetchUser
  get authorName(): string {
    return this.isRegistered ? this.author.name || this.author.username || '' : this.__('Anonymous')
  }
  toggleDropdown(): void {
    this.$emit('show-comment-action-menu')
  }
  onEscape(): void {
    if (this.isBeingEdited) {
      this.$emit('stop-editing')
    }
  }
  onOutsideClick(): void {
    if (this.isBeingEdited) {
      this.$emit('stop-editing')
    }
  }
  submitEdit(): void {
    const newBody = this.editingDraftBody
    if (newBody?.trim() !== '') {
      this.$emit('edit', {
        id: this.id,
        body: newBody,
      })
    }
  }

  get editingDraftBody(): string {
    return this.editedDraftCommentBodyFromId(this.id)
  }

  set editingDraftBody(newBody: string) {
    this.updateEditedDraftCommentBody({ commentId: this.id, body: newBody })
  }
}
